var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowbiteClockOutlineDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flowbite:clock-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7773 11.5C21.7773 12.6819 21.5446 13.8522 21.0923 14.9442C20.64 16.0361 19.977 17.0282 19.1413 17.864C18.3056 18.6997 17.3134 19.3626 16.2215 19.8149C15.1296 20.2672 13.9592 20.5 12.7773 20.5C11.5954 20.5 10.4251 20.2672 9.33319 19.8149C8.24126 19.3626 7.24911 18.6997 6.41338 17.864C5.57766 17.0282 4.91472 16.0361 4.46243 14.9442C4.01014 13.8522 3.77734 12.6819 3.77734 11.5C3.77734 9.11305 4.72556 6.82387 6.41338 5.13604C8.10121 3.44821 10.3904 2.5 12.7773 2.5C15.1643 2.5 17.4535 3.44821 19.1413 5.13604C20.8291 6.82387 21.7773 9.11305 21.7773 11.5Z",
    stroke: "#008CA5",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M12.7773 7.5V11.5L15.7773 14.5",
    stroke: "#008CA5",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowbiteClockOutlineDark);
export default __webpack_public_path__ + "static/media/flowbite_clock-outline_Dark.a069489b1a96d50d66e83c351a2b02d3.svg";
export { ForwardRef as ReactComponent };